import * as React from 'react';
import { MessageBoxFunctionalLayout, Modal } from '@wix/design-system';
import { WithTranslation, withTranslation } from 'react-i18next';
import ConcurrentWarningSVG from '../../../assets/images/ConcurrentWarningSVG.svg?url';

interface ConcurrentWarningProps extends WithTranslation {
  isModalOpened: boolean;
  onRefreshData: () => void;
  closeModal: () => void;
}

export const ConcurrentWarning = withTranslation()(
  ({ isModalOpened, onRefreshData, closeModal, t }: ConcurrentWarningProps) => {
    const onOk = () => {
      closeModal();
      onRefreshData();
    };

    return (
      <Modal isOpen={isModalOpened} onRequestClose={closeModal}>
        <MessageBoxFunctionalLayout
          title={t('translation:price_quote_view.concurrent-warning.title')}
          confirmText={t(
            'translation:price_quote_view.concurrent-warning.confirm-action',
          )}
          cancelText={t(
            'translation:price_quote_view.concurrent-warning.cancel-action',
          )}
          theme="blue"
          dataHook="concurrent-warning"
          onOk={onOk}
          onClose={closeModal}
          onCancel={closeModal}
          image={<img src={ConcurrentWarningSVG} />}
        >
          {t('translation:price_quote_view.concurrent-warning.content')}
        </MessageBoxFunctionalLayout>
      </Modal>
    );
  },
);
